export default __webpack_public_path__ + "static/media/li-list.8b4649ab.svg";